import React, {useContext} from "react";
import UserContext from "../../common/UserContext";
import {useLocalization} from "@progress/kendo-react-intl";
import {
    cancelChangesKey,
    confirmKey,
    FSAenteringOverdraftKey,
    FSAhitsOverdraftKey,
    mainMessages,
} from "../../../assets/text/MultilingualText";
import {Dialog, DialogActionsBar} from "@progress/kendo-react-dialogs";
import {Button} from "@progress/kendo-react-buttons";

export const OverdraftModal = (props) => {

    const {
        setShowModal,
        confirmationAction,
    } = props

    const {
        siteLanguageDefault
    } = useContext(UserContext);

    const localization = useLocalization();

    const closeModal = () => {
        setShowModal(false);
    }

    return (
        <Dialog
            className={"ksm-dialog"}
            title={<h2 style={{
                fontWeight: "normal",
                margin: 0,
                color: 'var(--color-text-primary)'
            }}>
                {localization.toLanguageString(FSAenteringOverdraftKey, mainMessages[siteLanguageDefault][FSAenteringOverdraftKey])}
            </h2>}
            onClose={closeModal}
            width={"40rem"}
            height={"15rem"}
        >
            <div style={{
                display: "flex",
                flexDirection: "column",
                gap: '1rem'
            }}>
                {localization.toLanguageString(FSAhitsOverdraftKey, mainMessages[siteLanguageDefault][FSAhitsOverdraftKey])}
            </div>
            <DialogActionsBar layout="center">
                <Button
                    themeColor={"primary"}
                    size={"large"}
                    fillMode={"outline"}
                    type={"button"}
                    onClick={closeModal}
                >
                    {localization.toLanguageString(cancelChangesKey, mainMessages[siteLanguageDefault][cancelChangesKey])}
                </Button>
                <Button
                    themeColor={"primary"}
                    size={"large"}
                    fillMode={"solid"}
                    type={"button"}
                    onClick={confirmationAction}
                >
                    {localization.toLanguageString(confirmKey, mainMessages[siteLanguageDefault][confirmKey])}
                </Button>
            </DialogActionsBar>
        </Dialog>
    )
}